const MANA = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
      fill="url(#paint0_linear)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.08496 6.5V14H13.335L7.08496 6.5Z"
      fill="url(#paint1_linear)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.834961 14H7.08496V6.5L0.834961 14Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 16C2.57 16.755 3.245 17.43 4 18H16C16.755 17.43 17.43 16.755 18 16H2Z"
      fill="#FC9965"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 18C5.67 19.255 7.75 20 10 20C12.25 20 14.33 19.255 16 18H4Z"
      fill="#FF2D55"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.4149 10.5V16H17.9999L13.4149 10.5Z"
      fill="url(#paint2_linear)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.415 14H0.834961C1.14496 14.715 1.53996 15.385 1.99996 16H13.42V14H13.415Z"
      fill="#FFBC5B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.83496 16H13.4149V10.5L8.83496 16Z"
      fill="white"
    />
    <path
      d="M13.415 9C14.7957 9 15.915 7.88071 15.915 6.5C15.915 5.11929 14.7957 4 13.415 4C12.0343 4 10.915 5.11929 10.915 6.5C10.915 7.88071 12.0343 9 13.415 9Z"
      fill="#FFC95B"
    />
    <path
      d="M7.08496 5C7.77532 5 8.33497 4.44036 8.33497 3.75C8.33497 3.05964 7.77532 2.5 7.08496 2.5C6.39461 2.5 5.83496 3.05964 5.83496 3.75C5.83496 4.44036 6.39461 5 7.08496 5Z"
      fill="#FFC95B"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="17.071"
        y1="2.929"
        x2="2.929"
        y2="17.071"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF2D55" />
        <stop offset="1" stop-color="#FFBC5B" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="10.2078"
        y1="6.5"
        x2="10.2078"
        y2="14"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A524B3" />
        <stop offset="1" stop-color="#FF2D55" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="15.7059"
        y1="10.5"
        x2="15.7059"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A524B3" />
        <stop offset="1" stop-color="#FF2D55" />
      </linearGradient>
    </defs>
  </svg>
);
export default MANA;
